export const fi = {
  translation: {
    yes: 'Kyllä',
    no: 'Ei',
    i_dont_know: 'En tiedä',
    loading: 'Ladataan',
    error: 'Virhe',
    what_its_about: 'Mitä asiasi koskee?',
    illness: 'Sairaus/oire',
    other_reason: 'Muu',
    next: 'Seuraava',
    digichat247: 'Digihoitaja chat työterveysasiakkaille 24/7',
    return_to_start: 'Palaa alkuun ja tyhjennä vastaukset',
    start_by_giving_anamnesis: 'Aloita antamalla esitiedot',
    chat_preliminary_questionaire: 'Chat-esitietokysely',
    start_preliminary_questionaire: 'Aloita esitietokysely',
    search: 'Etsi',
    search_for_symptoms: 'Hae oiretta tai sairautta',
    search_continue_writing: 'Jatka kirjoittamista',
    search_no_results:
      'Ei hakutuloksia. Kokeile toista hakusanaa tai kirjoita ”Hakutulosta ei löydy”, jonka valitsemalla voit ohittaa oirevalinnan.',
    step_your_symptoms: 'Oireesi',
    step_questions: 'Kysymykset',
    step_summary: 'Yhteenveto',
    what_symptoms_you_have: 'Mitä oireita sinulla on?',
    most_popular_symptoms: 'Yleisimpiä oireita',
    select_symptom: 'Valitse oire',
    remove_selected_symptom: 'Poista valittu oire',
    symptoms_you_chose: 'Valitsemasi oireet',
    no_selected_symptoms: 'Ei valittuja oireita',
    select_symptoms_and_proceed: 'Valitse 1-3 merkittävintä oiretta',
    error_max_selected_symptoms: 'Voit valita maksimissaan 3 oiretta tai sairautta.',
    popular_symptoms_flu: 'Flunssa',
    popular_symptoms_coronavirus: 'Koronavirus',
    popular_symptoms_sore_throat: 'Kurkkukipu',
    popular_symptoms_back_pain: 'Selkäkipu',
    popular_symptoms_knee_pain: 'Polvikipu',
    popular_symptoms_shoulder_pain: 'Olkapääkipu',
    popular_symptoms_neck_pain: 'Niskakipu',
    popular_symptoms_stomach_ache: 'Vatsakipu',
    popular_symptoms_stomach_flu: 'Vatsatauti',
    popular_symptoms_diarrhea: 'Ripuli',
    answer_to_questions: 'Vastaa kysymyksiin',
    your_symptoms_duration: 'Kauanko oireesi ovat kestäneet',
    under_one_day: 'Alle 1 vrk',
    one_to_two_days: '1 - 2 vrk',
    two_to_three_days: '2 - 3 vrk',
    over_three_days: 'Yli 3 vrk',
    more_information: 'Lisätietoja',
    write_information: 'Kirjoita tiedot',
    error_missing_information: 'Vastaa kaikkiin kysymyksiin',
    error_remote_data_failure:
      'Esitietokyselyn näyttäminen ei nyt onnistu. Kokeile ladata sivu uudelleen tai jatkaa suoraan chat-vastaanotolle.',
    summary: 'Yhteenveto',
    continue_to_chat: 'Jatka chattiin',
    your_answers_are_send_to_specialist: 'Esitiedot välitetään asiantuntijalle siirtyessäsi chattiin',
    choose_what_symptoms_you_have: 'Valitse mitä oireita sinulla on',
    answer_to_specifying_questions: 'Vastaa tarkentaviin kysymyksiin',
    check_summary_and_continue_to_chat: 'Tarkista yhteenveto ja siirry chat-jonoon',
    patient: 'Potilas',
    reason_of_contacting: 'Yhteydenoton syy',
  },
};
